exports.SERVERMESSAGE ={
  ALLOW : "ALLOW",
  SUCCESS : "SUCCESS"
}